import { Box, Button } from "@mui/material";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";

export const logout = async () => {
  await signOut(auth);
};

export default function More() {
  return (
    <Box sx={{}}>
      <Button
        variant="contained"
        onClick={logout}
        disableElevation
        sx={{ width: 100, height: 40, borderRadius: 1 }}
      >
        Sign Out
      </Button>
    </Box>
  );
}
